"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importDefault(require("react"));
const DurationLabel_1 = tslib_1.__importDefault(require("../../../ui-lib/DurationLabel"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const ModularDurationLabel = (0, mobx_react_lite_1.observer)(({ ...props }) => {
    // Needs to be implemented in API
    // const ctx = useContext<EncoderUiState | null>(EncoderUiContext);
    // const hasUndefinedStore: () => boolean = () =>
    //   !!(ctx === undefined || ctx.duration === undefined || ctx.duration.display === undefined);
    // useUndefinedStoreError(hasUndefinedStore, "<DurationLabel/>");
    // if (ctx?.duration?.display) {
    //   return <DurationLabel {...props}>{ctx.duration.display}</DurationLabel>;
    // }
    return react_1.default.createElement(react_1.default.Fragment, null);
});
const DurationLabelWithErrorBoundary = ({ ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(DurationLabel_1.default, { ...props }, "Duration Unavailable") },
        react_1.default.createElement(ModularDurationLabel, { ...props })));
};
exports.default = DurationLabelWithErrorBoundary;
//# sourceMappingURL=index.js.map